const pino = require('pino');

const productionLogLevel = process.env.LOG_LEVEL || 'info';
const devLogLevel = process.env.LOG_LEVEL || 'trace';

const logger = pino({
  prettyPrint: process.env.NODE_ENV === 'development',
  level: process.env.NODE_ENV === 'production' ? productionLogLevel : devLogLevel,
  formatters: {
    level(label) {
      return { level: label };
    },
    bindings() {
      return {};
    }
  },
  timestamp() {
    return `,"timestamp":${Date.now()}`;
  },
  redact: ['req.headers.authorization', 'req.headers["x-api-key"]', 'queryParams.token']
});

const wrapper = {
  instance() {
    return logger;
  },
  trace(message, ...args) {
    logger.trace(message, ...args);
  },
  debug(message, ...args) {
    logger.debug(message, ...args);
  },
  info(message, ...args) {
    logger.info(message, ...args);
  },
  warn(message, ...args) {
    logger.warn(message, ...args);
  },
  error(message, ...args) {
    logger.error(message, ...args);
  },
  fatal(message, ...args) {
    logger.fatal(message, ...args);
  }
};

module.exports = {
  logger: wrapper
};
